import React from "react";
import Hls from "hls.js";

class VideoPlayer extends React.Component {

  componentDidMount() {
    console.log('VIDEO componentDidMount called', this.props.url);
    if(Hls.isSupported()){
      console.log("HLS supported on this device.")
      const video = this.player;
      const hls = new Hls();
      const url = this.props.url;
      hls.loadSource(url);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, function() { video.play(); });
    } else {
      console.log("HLS not supported on this device.")
    }
  }

  render() {
    return (
      <div style={{"marginTop": 35}}>
        {Hls.isSupported() ?
          <video style={{"borderRadius": "5px"}}
            className="videoCanvas"
            ref={player => (this.player = player)}
            autoPlay
            playsInline
            controls
            width={300}
          />
          :
          <video style={{"borderRadius": "5px"}}
            className="videoCanvas"
            src={this.props.url}
            autoPlay
            playsInline
            controls
            width={300}
          />
        }
      </div>
    );
  }
}

export default VideoPlayer;